import React from "react";
import { useTranslation } from "react-i18next";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useStableScopedDomId } from "../../useStableDomId";
import { RotateCcw } from '../../emailBuilderIcons';

export function ResetButton({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation();
  const label = t("Reset to default");
  const tooltipId = useStableScopedDomId("email-builder-settings-reset", "default");

  return (
    <OverlayTrigger
      placement="left"
      delay={{ show: 400, hide: 100 }}
      overlay={<Tooltip id={tooltipId}>{label}</Tooltip>}
    >
      <button
        type="button"
        className={"email-builder-settings-reset-icon-btn"}
        aria-label={label}
        onClick={onClick}>
        <RotateCcw size={14} aria-hidden />
      </button>
    </OverlayTrigger>
  );
}
